import React from 'react';
import { motion } from 'framer-motion';
import { MonitorIcon, GlobeIcon, SmartphoneIcon, VideoIcon, SparklesIcon } from 'lucide-react';
const eras = [{
  year: '1980s',
  name: 'Computers',
  desc: 'Digitizing paper processes.',
  icon: MonitorIcon
}, {
  year: '1990s',
  name: 'Internet',
  desc: 'Global connectivity & browsers.',
  icon: GlobeIcon
}, {
  year: '2000s',
  name: 'Mobile',
  desc: 'Apps and computing anywhere.',
  icon: SmartphoneIcon
}, {
  year: '2020s',
  name: 'Remote',
  desc: 'Zoom/Teams redefining collaboration.',
  icon: VideoIcon
}, {
  year: 'Now',
  name: 'AI & Agents',
  desc: 'Autonomous reasoning & execution.',
  icon: SparklesIcon,
  highlight: true
}];
export function TimelineSection() {
  return <section id="timeline" className="py-24 md:py-32 bg-background relative overflow-hidden" data-id="element-239">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-240">
        <div className="mb-16 md:mb-24 max-w-2xl" data-id="element-241">
          <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-242">
            The 5th Great Shift
          </h2>
          <p className="text-lg text-neutral-600" data-id="element-243">
            Every few decades, a new technology fundamentally changes how
            business operates. Those who adapt early gain insurmountable
            leverage.
          </p>
        </div>

        <div className="relative" data-id="element-244">
          {/* Desktop horizontal line */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-neutral-100 -translate-y-1/2 z-0" data-id="element-245" />

          {/* Animated drawing line (desktop) */}
          <motion.div className="hidden md:block absolute top-1/2 left-0 h-0.5 bg-neutral-300 -translate-y-1/2 z-0 origin-left" initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-246" />

          {/* Mobile vertical line */}
          <div className="md:hidden absolute top-0 bottom-0 left-8 w-0.5 bg-neutral-100 z-0" data-id="element-247" />

          {/* Animated drawing line (mobile) */}
          <motion.div className="md:hidden absolute top-0 left-8 w-0.5 bg-neutral-300 z-0 origin-top" initial={{
          scaleY: 0
        }} whileInView={{
          scaleY: 1
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-248" />

          <div className="flex flex-col md:flex-row justify-between gap-12 md:gap-4 relative z-10" data-id="element-249">
            {eras.map((era, i) => {
            const Icon = era.icon;
            return <motion.div key={i} className={`flex md:flex-col items-start md:items-center gap-6 md:gap-4 ${era.highlight ? 'md:-mt-4' : ''}`} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: i * 0.2
            }} viewport={{
              once: true,
              margin: '-50px'
            }} data-id="element-250">
                  <div className={`
                    relative flex-shrink-0 w-16 h-16 rounded-2xl flex items-center justify-center transition-all duration-500
                    ${era.highlight ? 'bg-foreground text-white shadow-xl shadow-accent/20 scale-110' : 'bg-white border border-neutral-200 text-neutral-600'}
                  `} data-id="element-251">
                    {era.highlight && <motion.div className="absolute inset-0 rounded-2xl border-2 border-accent" animate={{
                  scale: [1, 1.2, 1],
                  opacity: [0.5, 0, 0.5]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-252" />}
                    <Icon className={`w-6 h-6 ${era.highlight ? 'text-accent' : ''}`} data-id="element-253" />
                  </div>

                  <div className="md:text-center pt-2 md:pt-0" data-id="element-254">
                    <div className={`text-sm font-bold tracking-wider uppercase mb-1 ${era.highlight ? 'text-accent' : 'text-neutral-400'}`} data-id="element-255">
                      {era.year}
                    </div>
                    <h3 className="text-xl font-serif mb-2" data-id="element-256">{era.name}</h3>
                    <p className="text-sm text-neutral-500 max-w-[180px]" data-id="element-257">
                      {era.desc}
                    </p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}